import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TrustBar from "@/components/TrustBar";
import Services from "@/components/Services";
import About from "@/components/About";
import Opportunities from "@/components/TalentNetwork";
import JoinNetwork from "@/components/JoinNetwork";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  const location = useLocation();

  // Scroll to hash target when navigating to /#contact, /#opportunities, etc.
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.substring(1);
    // Wait a tick so sections have rendered
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 120);
    return () => clearTimeout(t);
  }, [location]);

  return (
    <main data-testid="home-page" className="bg-[#0E2750] text-white min-h-screen">
      <Navbar />
      <Hero />
      <TrustBar />
      <Services />
      <About />
      <Opportunities />
      <JoinNetwork />
      <Contact />
      <Footer />
    </main>
  );
}
